export enum FormTypeEnum{
    Informational,
    Action,
    Complain
}